import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { ProfileMain } from '../../organisms/settings/profile/ProfileMain';

const UserProfilePage: React.FC = () => (
  <SettingsAccessControl allowedRoles='systemAdmin'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <ProfileMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default UserProfilePage;
